export default __webpack_public_path__ + "static/media/vehicle.a6e2856caaf9104bfa0fd2805e52304b.svg";